// extracted by mini-css-extract-plugin
export default {"play-entry":"zi7Be3d06rUtI6mY1chg","play-icon":"iOcHOu0uS7yBPyAp_S52","type-default":"m880ONAOicU1XtWKXZd5","common_bganimation":"oIMzQdPX9BkgBc1bsj_1"};